import React from "react";
import "./tryoutTop.css";
import Button from "../../button/button";
import SimpleButtonWrapper from "../../simpleButtonWrapper/simpleButtonWrapper";

const RedocTryoutInfo = (props) => {
  const { method, path, onSubmit, loading } = props;
  return (
    <div className="tryout-form__top">
      <div className="tryout-form__top-left">
        <RedocTryoutMethod method={method} />
        <span className="path">{path}</span>
      </div>
      <div className="tryout-form__top-right">
        <SimpleButtonWrapper>
          <Button className="electro" onClick={onSubmit} disabled={loading}>
            Send
          </Button>
        </SimpleButtonWrapper>
      </div>
    </div>
  );
};

export const RedocTryoutMethod = (props) => {
  const { method } = props;
  return <span className={"method method-" + method}>{method}</span>;
};

export default RedocTryoutInfo;
